<template>
  <div>
    <div id="home">
      <img style="width: 18vw;margin:20px 0;" src="../assets/imgs/edit.png" />
      <h1>계산 전 입력 정보를<br/>확인해 주세요</h1>
      <div class="border">
        <div>
          입사일
          <b>{{moment(joinDate).format('YYYY-MM-DD')}}</b>
        </div>
        <div>
          퇴사일
          <b>{{moment(leaveDate).format('YYYY-MM-DD')}}</b>
        </div>
        <div>
          총임금(3개월)
          <b>{{formatNumber(salary)}}원</b>
        </div>
      </div>
      <div class="btn" @click="next()">
        다음
      </div>
      <div class="link" @click="reset()">
        다시 계산하기
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment/moment';
  export default {
    name: 'Confirm',
    components: {

    },
    data() {
      return {
        joinDate:'',
        leaveDate:'',
        salary:''
      }
    },
    created(){
      if(Vue.ls.get('joinDate')) {
        this.joinDate = Vue.ls.get('joinDate')
      } else {
        this.$router.push('/home')
      }

      if(Vue.ls.get('leaveDate')) {
        this.leaveDate = Vue.ls.get('leaveDate')
      } else {
        this.$router.push('/home')
      }

      if(Vue.ls.get('salary')) {
        this.salary = Vue.ls.get('salary')
      } else {
        this.$router.push('/home')
      }

    },
    methods:{
      moment,
      formatNumber(value) {
        return value.replaceAll(',','').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      reset(){
        Vue.ls.remove('joinDate')
        Vue.ls.remove('leaveDate')
        Vue.ls.remove('salary')
        this.$router.push('/')
      },
      next(){
        this.$router.push('/loading')
      }
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{height: 100vh;display: flex;flex-direction: column;width: 100%;padding:20px;}
  h1{color:#333333;font-size: 24px;}
  .btn{background:#4873FF;color:#ffffff;display: flex;position: fixed;bottom:60px;justify-content: center;margin-top:30px;align-items: center;width: calc(100vw - 40px);height: 52px;border-radius: 26px;font-weight: bold;}
  .link{color: #717B85;text-align: center;position: fixed;bottom:20px;width: 100%;left:0;}
  .border{border:1px solid #DDDDDD;padding:20px;border-radius: 20px;margin-top: 20px;display: grid;grid-template-columns: 1fr; gap: 10px;}
  .border div{display: flex;align-items: center;justify-content: space-between;color: #717B85;}
  .border b{color:#333333;}
</style>
